module.exports = __webpack_public_path__ + "7c1a60bf2d57c3fd8c46522ba97ebf0b.jpg";